import styled, { css } from "styled-components"

export const ContentWrapper = styled.div`
    ${(props) =>
        !props.isAdmin &&
        css`
        margin-top: 92px;
    `}
`
